import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../Basics/CustomButton/CustomButton.tsx";

interface ConfirmResetGeometryModalProps {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  isLoading: boolean;
  willSaveCoordinates?: boolean;
}

const ConfirmResetGeometryModal: React.FC<ConfirmResetGeometryModalProps> = ({
  open,
  onClose,
  onReset,
  isLoading,
  willSaveCoordinates = false,
}) => {
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="body1"
          component="p"
          style={{ textAlign: "center", marginTop: "16px" }}
        >
          Are you sure you want to reset this site's geometry?
        </Typography>
        <Typography
          variant="body2"
          component="p"
          style={{ textAlign: "center", marginTop: "12px" }}
        >
          {willSaveCoordinates
            ? "Unsaved latitude and longitude will be saved first. The existing polygon will then be deleted and replaced with a generated polygon."
            : "The existing polygon will be deleted and replaced with a generated polygon."}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
          <CustomButton
            disabled={isLoading}
            sx={{
              paddingY: 0.5,
            }}
            variant="outlined"
            color="secondary"
            label="Cancel"
            onClick={onClose}
          />
          <CustomButton
            disabled={isLoading}
            sx={{
              paddingY: 0.5,
            }}
            variant="contained"
            color="primary"
            label="Reset"
            onClick={onReset}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmResetGeometryModal;
